import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

window['GLightbox'] = GLightbox;

function initWebsiteLightbox() {
    // Product gallery is initialized on the product page so OrbitVU can
    // mount into the same carousel. Exclude those items here.
    if (document.querySelectorAll('.glightbox:not(.product-gallery-item)').length) {
        new GLightbox({
            selector: '.glightbox:not(.product-gallery-item)',
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWebsiteLightbox);
} else {
    initWebsiteLightbox();
}
